module.exports = __webpack_public_path__ + "img/file.caf03b80.png";